module.exports = __webpack_public_path__ + "img/badge.a9b05686.svg";